export const uiTokens = {
  colors: {
    bgGlass: 'rgba(10, 10, 12, 0.72)',
    bgElevated: 'rgba(15, 23, 42, 0.55)',
    borderSoft: 'rgba(255, 255, 255, 0.08)',
    borderMuted: 'rgba(148, 163, 184, 0.15)',
    textPrimary: '#f8fafc',
    textSecondary: '#94a3b8',
    accent: '#34d399',
    accentHover: '#5eead4',
    accentTextDark: '#0a0a0a',
    danger: '#f87171',
  },
  radius: {
    sm: '12px',
    md: '16px',
    lg: '20px',
    pill: '999px',
  },
  shadow: {
    soft: '0 8px 28px rgba(0, 0, 0, 0.25)',
    md: '0 12px 40px rgba(0, 0, 0, 0.35)',
  },
  typography: {
    sans: 'var(--sans, \'DM Sans\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', sans-serif)',
    serif: '\'Instrument Serif\', Georgia, serif',
  },
};

export type UiTone = 'default' | 'positive' | 'negative';
